import RupeeSymbol from './rupeeSymbol';
export default RupeeSymbol;
